@if (!hideNavbar) {
<app-toolbar (menuToggleEvent)="sideNav.toggleLeftMenu()" (clickEvent)="sideNav.toggleRightMenu($event)" />
<app-sidenav #sideNav />
}